export default (data = {}) => {
    return {
        payment_code: '01',
        payment_concept: 'EFECTIVO',
        payment_reference: '',
        payment_value: 0,
        ...data
    }
}